import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { useABTest } from '../../context/abTestContext';
import { CONTROL_GROUP, useExperiment } from '../../hooks/useExperiment';
import { useEditorAsyncPropsContext } from '../../../../../../components';

interface ABTestGroupProps {
    children: React.ReactNode;
    groupNumber: number;
}

const ABTestGroup: React.FC<ABTestGroupProps> = ({ children, groupNumber }) => {
    const { previewGroup, testNumber } = useABTest();
    const { isEditMode } = useEditorAsyncPropsContext();
    const { abTests = {} } = getContext();
    const { isInGroup } = useExperiment(abTests, groupNumber, testNumber);

    const previewGroupData = previewGroup === 'all' ? 'all' : parseInt(previewGroup, 10);

    const shouldRenderChildren = () => {
        if (isEditMode) {
            return previewGroupData === 'all' || previewGroupData === groupNumber;
        }

        if (!testNumber && !isEditMode) {
            return groupNumber === CONTROL_GROUP;
        }

        return isInGroup;
    };

    if (!shouldRenderChildren()) {
        return null;
    }

    return <>{children}</>;
};

export default ABTestGroup;
